/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BookNonConfirmedConsultParams,
  BookNonConfirmedConsultWithPsychologistParams,
  GetNonConfirmedConsultParams,
  GetTimeSlotsInFirstAvailableWeek3Params,
  GetTimeSlotsInFirstAvailableWeekParams,
  LastCompletedConsultsByTypeParams,
  ModelsDtosTimezoneDto,
  ModelsTimeSlot,
  RequestAvailableTimeSlotsRequest,
  RequestBookSlotRequest,
  RequestCancelConsultRequest,
  RequestRescheduleConsultRequest,
  RequestReschedulerSlotByTagsRequest,
  RequestReschedulerSlotWithPsychologistRequest,
  ResponseConsultResponse,
  ResponseLastCompletedConsultByTypeResponse,
  ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse,
  ResponseTwoFactorNotEnforcedConsultResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Scheduler<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Scheduler
   * @name BookConsult
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request POST:/api/v1/scheduler/book-consult
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  bookConsult = (data: RequestBookSlotRequest, params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedConsultResponse, void>({
      path: `/api/v1/scheduler/book-consult`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name BookConsultWithClient
   * @summary Book a consult with a client (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/scheduler/book-consult-with-client/{clientId}
   * @secure
   * @response `200` `ResponseConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  bookConsultWithClient = (clientId: string, data: RequestBookSlotRequest, params: RequestParams = {}) =>
    this.http.request<ResponseConsultResponse, void>({
      path: `/api/v1/scheduler/book-consult-with-client/${clientId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name BookConsultWithClientAndExpert
   * @summary  (Auth policies: HostOrExpertPolicy)
   * @request POST:/api/v1/scheduler/book-consult-with-client/{clientId}/{psychologistId}
   * @secure
   * @response `200` `ResponseConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  bookConsultWithClientAndExpert = (
    clientId: string,
    psychologistId: string,
    data: RequestBookSlotRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseConsultResponse, void>({
      path: `/api/v1/scheduler/book-consult-with-client/${clientId}/${psychologistId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name BookConsultWithPsychologist
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request POST:/api/v1/scheduler/book-consult/{psychologistId}
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  bookConsultWithPsychologist = (psychologistId: string, data: RequestBookSlotRequest, params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedConsultResponse, void>({
      path: `/api/v1/scheduler/book-consult/${psychologistId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name BookNonConfirmedConsult
   * @request POST:/api/v1/scheduler/book-non-confirmed-consult
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse` OK
   */
  bookNonConfirmedConsult = (
    query: BookNonConfirmedConsultParams,
    data: RequestBookSlotRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse, any>({
      path: `/api/v1/scheduler/book-non-confirmed-consult`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name BookNonConfirmedConsultWithPsychologist
   * @request POST:/api/v1/scheduler/book-non-confirmed-consult/{psychologistId}
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse` OK
   */
  bookNonConfirmedConsultWithPsychologist = (
    { psychologistId, ...query }: BookNonConfirmedConsultWithPsychologistParams,
    data: RequestBookSlotRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse, any>({
      path: `/api/v1/scheduler/book-non-confirmed-consult/${psychologistId}`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name CancelConsult
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request DELETE:/api/v1/scheduler/consult/{consultId}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  cancelConsult = (consultId: number, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/scheduler/consult/${consultId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name CancelConsult2
   * @summary  (Auth policies: HostOrSupportOrExpertOrManagerPolicy)
   * @request PUT:/api/v1/scheduler/consult/{consultId}/cancel
   * @originalName cancelConsult
   * @duplicate
   * @secure
   * @response `200` `ResponseConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  cancelConsult2 = (consultId: number, data: RequestCancelConsultRequest, params: RequestParams = {}) =>
    this.http.request<ResponseConsultResponse, void>({
      path: `/api/v1/scheduler/consult/${consultId}/cancel`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name GetNonConfirmedConsult
   * @request GET:/api/v1/scheduler/non-confirmed-consult
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse` OK
   */
  getNonConfirmedConsult = (query: GetNonConfirmedConsultParams, params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse, any>({
      path: `/api/v1/scheduler/non-confirmed-consult`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name GetTimeSlotsInFirstAvailableWeek
   * @request GET:/api/v1/scheduler/time-slots/available/{psychologistId}
   * @secure
   * @response `200` `(ModelsTimeSlot)[]` OK
   */
  getTimeSlotsInFirstAvailableWeek = (
    { psychologistId, ...query }: GetTimeSlotsInFirstAvailableWeekParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ModelsTimeSlot[], any>({
      path: `/api/v1/scheduler/time-slots/available/${psychologistId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name GetTimeSlotsInFirstAvailableWeek2
   * @request POST:/api/v1/scheduler/time-slots/available
   * @originalName getTimeSlotsInFirstAvailableWeek
   * @duplicate
   * @secure
   * @response `200` `(ModelsTimeSlot)[]` OK
   */
  getTimeSlotsInFirstAvailableWeek2 = (data: RequestAvailableTimeSlotsRequest, params: RequestParams = {}) =>
    this.http.request<ModelsTimeSlot[], any>({
      path: `/api/v1/scheduler/time-slots/available`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name GetTimeSlotsInFirstAvailableWeek3
   * @summary  (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/scheduler/time-slots/available
   * @originalName getTimeSlotsInFirstAvailableWeek
   * @duplicate
   * @secure
   * @response `200` `(ModelsTimeSlot)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getTimeSlotsInFirstAvailableWeek3 = (query: GetTimeSlotsInFirstAvailableWeek3Params, params: RequestParams = {}) =>
    this.http.request<ModelsTimeSlot[], void>({
      path: `/api/v1/scheduler/time-slots/available`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name GetTimezones
   * @request GET:/api/v1/scheduler/timezones
   * @secure
   * @response `200` `(ModelsDtosTimezoneDto)[]` OK
   */
  getTimezones = (params: RequestParams = {}) =>
    this.http.request<ModelsDtosTimezoneDto[], any>({
      path: `/api/v1/scheduler/timezones`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name LastCompletedConsult
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/scheduler/last-completed-consult
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  lastCompletedConsult = (params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedConsultResponse, void>({
      path: `/api/v1/scheduler/last-completed-consult`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name LastCompletedConsultsByType
   * @summary This api is for showing SessionTypes to book a follow-up consult (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/scheduler/last-completed-consults-by-type
   * @secure
   * @response `200` `(ResponseLastCompletedConsultByTypeResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  lastCompletedConsultsByType = (query: LastCompletedConsultsByTypeParams, params: RequestParams = {}) =>
    this.http.request<ResponseLastCompletedConsultByTypeResponse[], void>({
      path: `/api/v1/scheduler/last-completed-consults-by-type`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name LastCompletedConsultWithPsychologist
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/scheduler/last-completed-consult/{psychologistId}
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  lastCompletedConsultWithPsychologist = (psychologistId: string, params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedConsultResponse, void>({
      path: `/api/v1/scheduler/last-completed-consult/${psychologistId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name RescheduleConsult
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request POST:/api/v1/scheduler/reschedule-with-psychologist
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  rescheduleConsult = (data: RequestReschedulerSlotWithPsychologistRequest, params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedConsultResponse, void>({
      path: `/api/v1/scheduler/reschedule-with-psychologist`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name RescheduleConsult2
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request POST:/api/v1/scheduler/reschedule-with-tags
   * @originalName rescheduleConsult
   * @duplicate
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  rescheduleConsult2 = (data: RequestReschedulerSlotByTagsRequest, params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedConsultResponse, void>({
      path: `/api/v1/scheduler/reschedule-with-tags`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name RescheduleConsult3
   * @summary  (Auth policies: HostOrExpertPolicy)
   * @request PUT:/api/v1/scheduler/consult/{consultId}/reschedule
   * @originalName rescheduleConsult
   * @duplicate
   * @secure
   * @response `200` `ResponseConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  rescheduleConsult3 = (consultId: number, data: RequestRescheduleConsultRequest, params: RequestParams = {}) =>
    this.http.request<ResponseConsultResponse, void>({
      path: `/api/v1/scheduler/consult/${consultId}/reschedule`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scheduler
   * @name ResynchronizeCalendar
   * @summary Resynchronize the calendar of an expert (Auth policies: SupportPolicy)
   * @request PUT:/api/v1/scheduler/resynchronize-calendar/{userId}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  resynchronizeCalendar = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/scheduler/resynchronize-calendar/${userId}`,
      method: "PUT",
      secure: true,
      ...params,
    });
}
